export const QUERY_STRING_PREV_STEP_OVERRIDE: string = 'mockPreviousStep';

export const PENDING_REDIRECT = 'https://services.lumion3d.net/api/students/status?verificationId=';
export const SUCCESS_REDIRECT = 'https://services.lumion3d.net/api/students/status?verificationId=';
